export function getFormDataNew(form) {
	return Object.fromEntries(new FormData(form).entries())
}

export function getFormData(form) {
	let elements = Array.from(form.elements).filter((x) => !x.disabled)
	elements = elements.filter((x) => x.type !== 'radio' || x.checked)
	let entries = elements.map((x) => [x.name ?? x.id, x.value])
	entries = entries.filter((x) => x[0])
	return Object.fromEntries(entries)
}
